import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "App";
import 'antd/dist/reset.css';


// 拼好房 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { ToastProvider } from "components/Toast/index";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
    <HashRouter basename="/">
      <MaterialUIControllerProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </MaterialUIControllerProvider>
    </HashRouter>
);
